export const handlePayment = (reference, currency, value) => {
  const redirect = `${process.env.REACT_APP_PAYMENT_REDIRECT}`;
  const publicKey = `${process.env.REACT_APP_PAYMENT_PUBLIC_TOKEN}`;
  const url = "https://checkout.wompi.co/p/";
  const params = `public-key=${publicKey}&currency=${currency}&amount-in-cents=${
    value * 100
  }&reference=${reference}&redirect-url=${redirect}`;
  window.location.assign(`${url}?${params}`);
};
